export {
    descriptionPositionType,
    labelPositionType,
    popupPositionType,
    descriptionPositionValues,
    timeFormatWithSeconds,
    timeFormatWithoutSeconds,
    Constants,
    LoadingState
} from 'shell-models-lib';

export const SMALL_SCREEN_WIDTH = 640;
export const SMALL_SCREEN_WIDTH_480PX = 480;
export const SMALL_SCREEN_HEIGHT_640PX = 640;
export const SMALL_SCREEN_HEIGHT_480PX = 480;
export const LARGE_SCREEN_MIN_WIDTH = 1024;

export const SQL_PORT_1443 = '1443';
export const SQL_PORT_443 = '443';

export const MAX_INT32 = 2147483647;

export enum Orientation {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical'
}
